import React from 'react';

const TipContainer = ({ children, extra = null }) => (
  <div className="value-driver-tip-container">
    {extra ? (
      <>
        In $({extra})
        <br />
        <br />
      </>
    ) : null}
    {children}
  </div>
);

const scaleTip = (
  <TipContainer>
    For high level estimates, use the Scale selection to select “Low”,”Medium”,
    and “High” options in lieu of dollar figures.
  </TipContainer>
);

const dollarTip = (
  <TipContainer>
    If diligence has been conducted and actual synergy dollar values can be
    estimated, select this option to input all values in dollar figures.
  </TipContainer>
);

const clientEBITDATip = (
  <TipContainer>
    Pre-populated EBIT reflects latest reported data, if available. Insert
    desired EBIT value for the Buyer/Target
  </TipContainer>
);

const targetEBITDATip = (
  <TipContainer>
    Pre-populated EBITDA reflects latest reported data, if available. Insert
    desired EBITDA value for the Target.
  </TipContainer>
);

const denTip = (
  <TipContainer>
    Estimated adjustment as the % of combined EBITDA based on diligence. Input
    as positive or negative percentage, as appropriate. Leave blank if no
    diligence or adjustments are required.
  </TipContainer>
);

const probabilityTip = (
  <TipContainer>
    Estimated probability of success based on complexity of the project, level
    of effort, degree of change, resources and time required to realize full
    value of synergy, regulatory requirements, and / or likely competitor or
    customer reactions.
  </TipContainer>
);

const timeToAchieveTip = (
  <TipContainer>Estimated timeframe to realize synergies.</TipContainer>
);

const financialImpactTip = (extra = null) => (
  <TipContainer extra={extra}>
    Estimated financial impact upon realization to combined synergized EBITDA.
    <br />
    <br />
    Scale selection guide (as % of combined EBITDA): <br />
    Low : 1% <br />
    Medium: 3%
    <br />
    High: 5% <br /> <br />
    For Dissynergies, scale selections will reflect a loss in value (i.e.,
    negative values applied)
  </TipContainer>
);

const oneTimeCostTip = (extra = null) => (
  <TipContainer extra={extra}>
    Estimated one-time costs (OTC) expected to realize synergies. <br />
    <br />
    Scale selection guide (as % of Synergy Value):
    <br />
    Low : &lt;10% <br />
    Medium: 10% - 50% <br />
    High: &gt; 50% <br />
    <br />
    Input absolute values as values will reflect a negative value when saved.
  </TipContainer>
);

export {
  clientEBITDATip,
  targetEBITDATip,
  scaleTip,
  dollarTip,
  denTip,
  probabilityTip,
  timeToAchieveTip,
  financialImpactTip,
  oneTimeCostTip,
};
